var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtTherapyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2327_2551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3402 8.61997L20.7102 8.86997C20.3186 8.93333 19.9174 8.90293 19.5398 8.78128C19.1621 8.65962 18.8187 8.45017 18.5377 8.1701C18.2566 7.89003 18.046 7.54733 17.923 7.1701C17.8 6.79287 17.7682 6.39186 17.8302 5.99997L18.0802 4.36997C18.1591 3.87349 18.1368 3.36619 18.0147 2.87854C17.8926 2.3909 17.6732 1.93297 17.3696 1.53227C17.066 1.13156 16.6846 0.796359 16.2482 0.546788C15.8119 0.297216 15.3295 0.138429 14.8302 0.0799658C12.0776 -0.22808 9.29734 0.327013 6.87406 1.66843C4.45078 3.00986 2.50433 5.07129 1.30403 7.56748C0.103738 10.0637 -0.291054 12.8712 0.174285 15.6016C0.639623 18.3321 1.94209 20.8503 3.90145 22.808C5.86081 24.7657 8.3802 26.0661 11.111 26.5291C13.8418 26.9921 16.649 26.5949 19.1442 25.3925C21.6394 24.1901 23.6992 22.2419 25.0385 19.8175C26.3779 17.3931 26.9306 14.6123 26.6202 11.86C26.5618 11.362 26.4033 10.8809 26.1542 10.4458C25.9051 10.0106 25.5707 9.63027 25.1709 9.32763C24.7711 9.025 24.3143 8.8063 23.8278 8.68469C23.3414 8.56308 22.8354 8.54107 22.3402 8.61997Z",
    fill: "#9B1A9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2327_2551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.7,
    height: 26.72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtTherapyLogo);
export default __webpack_public_path__ + "static/media/artTherapyLogo.18f37ebb5aaf595037d6d4c4f401e751.svg";
export { ForwardRef as ReactComponent };